// eslint-disable-next-line max-len
import AjaxRequest from '@wgn/ajaxrequest';
import { CELLPHONE_RECOVERY_OPERATIONS } from '../../../../../static-source/constants/cellphone_recovery_operations';
import CellphoneRecoveryStepPhone from './step_phone';
import CellphoneRecoveryStepConfirmSms from '../../../../../static-source/components/cellphone_recovery_operations/step_confirm_sms';

import {
    CELLPHONE_RECOVERY_STORE_NAMESPACE,
    MUTATION_UPDATE_CELLPHONE_RECOVERY_SETTINGS,
} from '../store';

export const RESET_TYPES = {
    sms: Symbol('sms'),
};

const STEP_COMPONENT_PREFIX = 'cellphone-recovery-step-';

const STEPS = {
    phone: `${STEP_COMPONENT_PREFIX}phone`,
    confirm_sms: `${STEP_COMPONENT_PREFIX}confirm-sms`,
};

export default {
    name: 'cellphone-recovery',
    template: '#js-tmpl-cellphone-recovery',
    components: {
        CellphoneRecoveryStepPhone,
        CellphoneRecoveryStepConfirmSms,
    },
    data() {
        return {
            STEPS,
            processing: false,
            pollingTimeout: null,
        };
    },
    mounted() {
        this.$store.commit(
            `${CELLPHONE_RECOVERY_STORE_NAMESPACE}/${MUTATION_UPDATE_CELLPHONE_RECOVERY_SETTINGS}`
        );
    },
    beforeDestroy() {
        this.stopStatusPolling();
    },
    computed: {
        store() {
            return this.$store.state[CELLPHONE_RECOVERY_STORE_NAMESPACE];
        },
        storeUpdateMutation() {
            return `${CELLPHONE_RECOVERY_STORE_NAMESPACE}/${MUTATION_UPDATE_CELLPHONE_RECOVERY_SETTINGS}`;
        },
        currentStepComponent() {
            const {
                showSmsDialog,
                showPhoneDialog,
                phoneConfirmed
            } = this.store;

            const STEPS_STATE_MACHINE = [
                {
                    step: STEPS.confirm_sms,
                    active: showSmsDialog || phoneConfirmed,
                },
                {
                    step: STEPS.phone,
                    active: showPhoneDialog,
                },
            ];

            const nextStep = STEPS_STATE_MACHINE.find(step => step.active);
            return nextStep ? nextStep.step : STEPS.phone;
        },
        stepComponentProps() {
            const operation = CELLPHONE_RECOVERY_OPERATIONS.cellphoneRecovery;

            return {
                operation,
                cancelOperationUrl: this.store.urls.passwordResetIndexUrl
            };
        }
    },
    methods: {
        updateComponentData(data = {}) {
            try {
                this.$store.commit(this.storeUpdateMutation, data);

                // If phone number is confirmed and server has returned the URL for the status pull
                if (data.phoneConfirmed && data.responseUrlStatus) {
                    this.startStatusPolling(data.responseUrlStatus);
                }
            } catch (error) {
                console.error('Error updating component data:', error);
            }
        },

        /**
         * FLASH CALL STATUS POLLING (MIG)
         */
        startStatusPolling(statusUrl) {
            this.stopStatusPolling();

            if (!statusUrl) return;

            const poll = () => {
                AjaxRequest.submit(
                    {},
                    {
                        url: statusUrl,
                        method: 'GET',
                        success: (data) => {
                            if (!data) return;

                            switch (data.status) {
                                case 'in_progress':
                                    this.pollingTimeout = setTimeout(poll, 3000);
                                    break;

                                case 'success':
                                    this.stopStatusPolling();
                                    // If necessary, you can update the state.
                                    // (for example, give a command to a child component,
                                    // like handleMigSuccess(data) on main auth flow by phone)
                                    break;

                                case 'failed':
                                    if (data.sms_data) {
                                        this.switchToSMSFlow(data.sms_data);
                                    }
                                    break;

                                default:
                                    break;
                            }
                        },
                        error: (xhr) => {
                            this.stopStatusPolling();
                            // Optional: handling specific errors (for example, 409 Conflict)
                            // somthing similar like in line 145 in file
                            // authentication/static-source/js/authentication/twofactor/twofactor.js
                            console.error('Flashcall polling error:', xhr);
                        }
                    }
                );
            };

            poll();
        },

        /**
         * POLLING STOP
         */
        stopStatusPolling() {
            if (this.pollingTimeout) {
                clearTimeout(this.pollingTimeout);
                this.pollingTimeout = null;
            }
        },

        /**
         * SWITCH TO SMS WHEN FLASH CALL FAIL
         */
        switchToSMSFlow(smsData) {
            this.stopStatusPolling();

            // restart timer
            // Update resendAvailableAt: current time stamp (ms) + interval from settings
            const intervalMinutes = this.store.intervalMs || 1;
            const newResentAvailableAt = Math.floor(Date.now() / 1000) + (intervalMinutes * 60);

            // Updating the Vuex Store. The child component step_confirm_sms must
            // react to the change in notificationType and urls by switching the form
            this.$store.commit(this.storeUpdateMutation, {
                notificationType: 'sms',
                twofactorMethod: 'sms',
                responseUrlValidate: smsData.validate,
                responseUrlResend: smsData.resend,
                resendAvailableAt: newResentAvailableAt,
            });
        }
    },
};
